import React from 'react';

const NotFound = () => {
  return <div>404 Not found page</div>;
};

export default NotFound;
